// src/components/progress/ProgressSidebarControls.js
import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import ToggleSwitch from '../common/ToggleSwitch';
import EnhancedSelect from '../common/EnhancedSelect';
import { levelMapping } from '../../utils/mappings';

const ProgressSidebarControls = ({ level, setLevel, srsStage, setSrsStage, status, setStatus, sortBy, setSortBy, contentType }) => {
  const [showTranslation, setTranslationVisibility] = useTranslation();

  return (
    <aside>
      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold text-content-primary">Filters</h3>
          <div className="mt-4 space-y-4">
            <div>
              <label htmlFor="level" className="block text-sm font-medium text-content-secondary pb-1">
                Level
              </label>
              <EnhancedSelect
                id="level"
                value={level}
                onChange={(e) => setLevel(e.target.value)}
                options={[
                  { value: 'all', label: 'All' },
                  ...Object.entries(levelMapping)
                    .filter(([key]) => contentType === 'words' || key !== '0')
                    .sort((a, b) => parseInt(b[0]) - parseInt(a[0]))
                    .map(([key, label]) => ({ value: key, label })),
                ]}
              />
            </div>

            <div>
              <label htmlFor="srs-stage" className="block text-sm font-medium text-content-secondary pb-1">
                SRS Stage
              </label>
              <EnhancedSelect
                id="srs-stage"
                value={srsStage}
                onChange={(e) => setSrsStage(e.target.value)}
                options={[
                  { value: 'all', label: 'All' },
                  { value: '0', label: 'Air' },
                  { value: '1', label: 'Wood' },
                  { value: '2', label: 'Silver' },
                  { value: '3', label: 'Gold' },
                  { value: '4', label: 'Diamond' },
                  { value: '5', label: 'Emerald' },
                  { value: '6', label: 'Ruby' },
                  { value: '7', label: 'Titanium' },
                ]}
              />
            </div>

            <div>
              <label htmlFor="status" className="block text-sm font-medium text-content-secondary pb-1">
                Status
              </label>
              <EnhancedSelect
                id="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                options={[
                  { value: 'all', label: 'All' },
                  { value: 'skipped', label: 'Skipped' },
                ]}
              />
            </div>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-border">
          <h3 className="text-lg font-semibold text-content-primary">Sorting</h3>
          <div className="mt-4 space-y-4">
            <div>
              <label htmlFor="sort-by" className="block text-sm font-medium text-content-secondary pb-1">
                Sort By
              </label>
              <EnhancedSelect
                id="sort-by"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                options={[
                  { value: 'level', label: 'Level' },
                  { value: 'srsStage', label: 'SRS Stage' },
                  { value: 'unlocked', label: 'Unlocked Date' },
                  { value: 'nextReview', label: 'Next Review Date' },
                ]}
              />
            </div>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-border">
          <h3 className="text-lg font-semibold text-content-primary">Display</h3>
          <div className="mt-4 space-y-4">
            <div className="flex items-center justify-between">
              <label className="text-sm font-medium text-content-secondary mr-2">Show Translation</label>
              <ToggleSwitch enabled={showTranslation} setEnabled={setTranslationVisibility} />
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ProgressSidebarControls;
